<template>
    <div class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
        <div class="bg-white p-6 rounded-lg w-11/12 md:w-3/4 max-h-[90vh] relative">
            <button 
                @click="$emit('close')"
                class="absolute top-4 left-4 text-gray-600 hover:text-gray-800"
                title="Volver"
            >
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
            </button>
            
            <div class="mt-8 max-h-[calc(90vh-8rem)] overflow-y-auto px-4">
                <h2 class="text-xl font-bold mb-4">Historial de seguimiento</h2>
                
                <template v-if="taskHistory && taskHistory.length > 0 && taskHistory[0].values && taskHistory[0].values[0].elements && taskHistory[0].values[0].elements.length > 0">
                    <div class="grid grid-cols-5 gap-4 mb-4 px-4 font-semibold text-sm text-gray-700 bg-white sticky top-0 z-10">
                        <div>Etapa</div>
                        <div>Asignado</div>
                        <div>Fecha</div>
                        <div>Completada</div>
                        <div>Razón de rechazo</div>
                    </div>

                    <div class="space-y-4">
                        <div v-for="element in taskHistory" :key="element.id">
                            <div>
                                <div v-for="value in element.values" :key="value.internalName">
                                    <div v-for="historyLine in value.elements" :key="historyLine.id" class="mb-4">
                                        <div class="grid grid-cols-5 gap-4 px-4 py-4 bg-white rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-all duration-200">
                                            <div v-for="historyElement in historyLine.values" 
                                                 :key="historyElement.internalName" 
                                                 class="text-sm break-words overflow-y-auto max-h-32">
                                                <span class="text-gray-600 whitespace-pre-wrap">
                                                    {{ historyElement.valueType === 'Date' ? formatFecha(historyElement.value) : (historyElement.value || '-') }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="flex flex-col items-center justify-center h-full">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 text-gray-400 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        <p class="text-xl text-gray-600 font-medium">No hay historial disponible</p>
                        <p class="text-gray-500 mt-2">No se encontraron registros de seguimiento para esta tarea</p>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits, onMounted, onUnmounted } from 'vue';
import type ITask from '@/interfaces/ITask';
import ApiService from '@/services/ApiService';

const props = defineProps<{
    task: ITask,
    userData: string
}>();

defineEmits<{
    close: []
}>();

const apiService = new ApiService();
const taskHistory = apiService.getDetailTask()

onMounted(async () => {
    document.body.style.overflow = 'hidden';
    if (props.task.processBaseReference) {
        await apiService.fetchTaskDetail(props.userData, props.task.processBaseReference);
    }
});

onUnmounted(() => {
    document.body.style.overflow = 'auto';
});

const formatFecha = (date: string | null) => {
    if (!date || date === "0001-01-01T00:00:00") return "-";
    const fecha = new Date(date);
    const dia = fecha.getDate();
    const mes = fecha.getMonth() + 1;
    const anio = fecha.getFullYear();
    return `${dia}/${mes}/${anio}`;
}
</script>

<style scoped>
</style> 